import { render, staticRenderFns } from "./DynamicAssociatedResourcesItems.vue?vue&type=template&id=b623cd2a&"
import script from "./DynamicAssociatedResourcesItems.vue?vue&type=script&lang=ts&"
export * from "./DynamicAssociatedResourcesItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports